module.exports = __webpack_public_path__ + "static/media/horoscope-icon-4.0eef4645.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-4.png
// module id = 1530
// module chunks = 0